import Header from "../../mobile/components/Header";
import React from "reactn";
import styled from "styled-components";

const Wrapper = styled.div``;

const Content = styled.div`
	padding: 21px;
	p {
		line-height: 1.6;
		text-align: justify;
	}

	h2 {
		font-family: Roboto, sans-serif;
	}
`;

const NoOp = () => (
	<div style={{ width: "22px", height: "20px" }}> &nbsp; </div>
);

const Terms = ({ history }) => {
	return (
		<Wrapper>
			<Header
				title="Términos y condiciones"
				icon={<NoOp />}
				goBack={history.goBack}
			/>
			<Content>
				<h1 id="condiciones-de-uso-plataforma-zeroq">
					Condiciones de uso plataforma ZeroQ
				</h1>
				<p>¡Bienvenidos a ZEROQ!</p>
				<p>
					ZeroQ es una plataforma virtual por la cual usted puede
					obtener un número de atención para realizar el trámite o
					servicio que necesite, siempre y cuando esté servicio esté
					adherido a ZeroQ. Dicho acceso puede ser realizado desde su
					celular o computador siempre que se encuentre conectado a
					una red wifi o cuente con datos móviles para acceder a
					zeroq.cl.
				</p>
				<p>
					Las presentes condiciones de uso de la página web, regulan
					los términos de acceso y uso de Zeroq.cl, propiedad de
					PANTHER MANAGEMENT SPA, en adelante, “la Empresa”, que el
					usuario del portal deberá aceptar para usar todos los
					servicios e información que se facilitan desde el portal.
				</p>
				<p>
					Por el solo hecho de acceder y utilizar este servicio se
					entiende que usted ha leído y aceptado plenamente estos
					términos y condiciones y que accede a estar obligado por los
					términos y disposiciones de este acuerdo. Asimismo, al
					utilizar estos servicios particulares, usted estará sujeto a
					toda regla o guía de uso correspondiente que se haya
					publicado para dichos servicios. Toda participación en este
					servicio constituirá la aceptación de este acuerdo. Si no
					acepta cumplir con lo anterior, por favor, no utilice el
					servicio.
				</p>
				<h2 id="derechos-de-propiedad-intelectual-e-industrial">
					Derechos de propiedad intelectual e industrial
				</h2>
				<p>
					La página y su contenido original, las características y la
					funcionalidad, incluyendo, sin limitación, hardware,
					software, imágenes, texto, gráficos, logotipos, patentes,
					marcas registradas, marcas de servicio, derechos de autor,
					fotografías, audio, videos, música y todos los Derechos de
					Propiedad Intelectual relacionados con ellos, son de
					propiedad exclusiva de PANTHER MANAGMENT Spa y están
					protegidos por la ley 17.336 de la República de Chile. Salvo
					que se indique explícitamente en este documento, no se
					considerará que nada en estos Términos crea una licencia en
					o bajo ninguno de dichos Derechos de Propiedad Intelectual,
					y usted acepta no vender, licenciar, alquilar, modificar,
					distribuir, copiar, reproducir, transmitir, exhibir
					públicamente, realizar públicamente, publicar, adaptar,
					editar o crear trabajos derivados de los mismos.
				</p>
				<p>
					Queda totalmente prohibido al Usuario cualquier tipo de
					explotación, utilización comercial, alteración,
					reproducción, distribución, cesión a terceros, comunicación
					pública, total o parcial, del Sitio Web y/o sus Contenidos,
					sin la autorización previa y expresa por escrito de PANTHER
					MANAGEMENT SPA o de los respectivos titulares de los
					derechos.
				</p>
				<p>
					El usuario a través de la aceptación de estos términos y
					condiciones se compromete a no vulnerar estos derechos de
					propiedad intelectual e industrial.
				</p>
				<h2 id="información-y-servicios">Información y servicios</h2>
				<p>
					Los usuarios pueden acceder a través del portal a diferentes
					tipos de información y servicios. El portal se reserva la
					facultad de modificar, en cualquier momento, y sin aviso
					previo, la presentación y configuración de la información y
					servicios ofrecidos desde el portal. El usuario reconoce y
					acepta expresamente que en cualquier momento el portal pueda
					interrumpir, desactivar y/o cancelar cualquier información o
					servicio. El portal realizará sus mejores esfuerzos para
					intentar garantizar la disponibilidad y accesibilidad a la
					web. No obstante, en ocasiones, por razones de
					mantenimiento, actualización, cambio de ubicación, etc.,
					podrá suponer la interrupción del acceso al portal.
				</p>
				<p>
					La empresa no cobra por el uso que usted haga de esta página
					y servicios que ella abarca, es decir, no tiene un cargo
					asociado para usted el hecho de ingresar a la pagina y
					seleccionar un número de atención para el servicio que usted
					eligió. Sin embargo, ZeroQ se reserva el derecho a
					introducir en el futuro cobros por algún otro servicio, lo
					cual será avisado por la plataforma web o aplicación para
					celular con un tiempo prudente de antelación.
				</p>
				<h2 id="disponibilidad-de-la-información-y-servicios-del-portal">
					Disponibilidad de la información y servicios del Portal
				</h2>
				<p>
					ZeroQ no garantiza la disponibilidad continua y permanente
					de los servicios, quedando de este modo exonerado de
					cualquier responsabilidad por posibles daños y perjuicios
					causados como consecuencia de la falta de disponibilidad del
					servicio por motivos de caso fortuito o fuerza mayor
					siguiendo el artículo 45 del Código Civil chileno, o errores
					en las redes telemáticas de transferencia de datos, ajenos a
					su voluntad, o por desconexiones realizadas por trabajos de
					mejora o mantenimiento de los equipos y sistemas
					informáticos. El portal no será responsable por la
					interrupción, suspensión o finalización de la información o
					servicios.
				</p>
				<p>
					ZeroQ al ser una plataforma electrónica están sujeta al
					riesgo de interrupciones, errores, fallas, intervenciones no
					autorizadas u obsolescencia. En atención a lo anterior y sin
					perjuicio de lo dispuesto en las otras secciones de estas
					Condiciones de Uso en materia de ausencia de garantías, ZeoQ
					no garantiza ni puede garantizar:
				</p>
				<ul>
					<li>
						<p>
							Que la página web o aplicación celular estará
							siempre disponible para ser utilizada o ingresar a
							ella
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular estén exentos
							de falla
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular estará
							siempre funcionando a tiempo real
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular calcularán el
							tiempo de espera de manera certera
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular no se queden
							pegados durante su utilización
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular no borren su
							turno de atención
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular cuente
							siempre con la visualización adecuada
						</p>
					</li>
					<li>
						<p>
							Que la página web o aplicación celular se vean de la
							forma originalmente planeada por ZeroQ en todos los
							celulares y sistemas operativos, la forma en como se
							ve la plataforma puede variar según su dispositivo.
						</p>
					</li>
				</ul>
				<p>
					Además, ZeroQ se reserva el derecho a limitar o interrumpir
					el acceso a nuestros Sitios Web, así como la oferta o
					prestación de cuantos servicios en ella se publiciten en
					cualquier momento y sin previo aviso, por motivos de
					mantenimiento, seguridad, fallo eléctrico, motivos técnicos
					u otros, sin que por ello se pueda derivar ninguna
					responsabilidad ni haya derecho a la solicitud de cualquier
					compensación económica. ZeroQ no asumirá́ ninguna
					responsabilidad ni directa ni indirecta por daños directos,
					indirectos o lucro cesante que se pueda derivar de la no
					disponibilidad de Nuestra Web o los servicios de ZeroQ.
				</p>
				<p>
					Tampoco responderá de los daños producidos por ataques
					informáticos o causados por virus que afecten a programas
					informáticos, sistemas de comunicaciones o equipos
					utilizados por el Portal, pero fabricados o facilitados por
					un tercero. El portal podrá, a su sola discreción, denegar,
					retirar, suspender y/o bloquear en cualquier momento y sin
					necesidad de previo aviso el acceso a la información y
					servicios a aquellos usuarios que incumplan las presentes
					normas.
				</p>
				<p>
					ZeroQ solo se hará cargo en caso de incumplir las
					condiciones de uso con culpa grave.
				</p>
				<h2 id="privacidad-del-usuario">Privacidad del Usuario</h2>
				<p>
					No vendemos sus datos personales ni compartimos información
					que se identifique directamente con usted (como nombre,
					dirección de correo electrónico, fotos, teléfono u otra
					información de contacto).
				</p>
				<p>
					Sus datos si pueden ser utilizados mediante los modelos de
					predicción de ZeroQ para poder recomendarle opciones más
					apropiadas a sus preferencias, historial de búsqueda,
					productos de interés u otros, todo esto con el fin de
					mejorar su experiencia de usuario.
				</p>
				<p>
					Nunca utilizaremos sus datos personales con una finalidad
					diferente a la expresada en condiciones de uso.
				</p>
				<h2 id="cambios-en-la-cuenta-del-usuario">
					Cambios en la cuenta del usuario
				</h2>
				<p>
					Informamos que es posible que tengamos que cambiar el nombre
					de usuario de su cuenta en determinadas circunstancias. Por
					ejemplo, si alguien reclama el nombre de usuario y no parece
					guardar relación con el nombre que usa en su vida cotidiana,
					si su nombre es ofensivo, irrisorio, grosero, sexualmente
					explícito, discriminador, entre otros; dentro del plazo de
					siete días.
				</p>
				<h2 id="suspensión-o-cancelación-de-la-cuenta">
					Suspensión o cancelación de la cuenta
				</h2>
				<p>
					Si la empresa se reserva el derecho de terminar o suspender
					de manera permanente o temporal su acceso al servicio sin
					previo aviso y responsabilidad si determina que usted
					incumple con las Condiciones en una o en reiteradas
					oportunidades.
				</p>
				<p>
					Cuando tomemos tal medida, le avisaremos y explicaremos las
					opciones que tienes para solicitar una revisión, a menos
					que, al hacerlo, nos expongamos o expongamos a otros a una
					responsabilidad legal; dañemos nuestra comunidad de
					usuarios; comprometamos la integridad o el funcionamiento de
					alguno de nuestros servicios, sistemas, o interfiramos con
					ellos; estemos restringidos por limitaciones técnicas; o
					tengamos prohibido hacerlo por motivos legales. 
				</p>
				<h2 id="reserva-de-acciones">Reserva de acciones</h2>
				<p>
					ZeroQ se reserva el derecho a ejercer todas las acciones que
					en derecho correspondan para exigir las responsabilidades
					que se deriven del incumplimiento de cualquiera de las
					disposiciones de estos términos y condiciones de uso.
				</p>
				<h2 id="legislación-aplicable-y-sistemas-de-solución-de-conflicto">
					Legislación aplicable y sistemas de solución de conflicto{" "}
				</h2>
				<p>
					Para los efectos mencionados y en el caso de controversias,
					ZeroQ y los usuarios de esta plataforma se someten a la
					legislación chilena.
				</p>
				<p>
					PANTHER MANAGEMENT SPA explicita que podrá ejercer acciones
					legales en contra de los usuarios de esta plataforma en caso
					de incumplir con sus condiciones de uso.
				</p>
				<h2 id="otros">Otros</h2>
				<p>
					La empresa se reserva el derecho de modificar estas
					condiciones en cuando lo considere oportuno; asimismo, el
					uso permanente de la página significará su aceptación de
					cualquier ajuste a tales términos. Si hay algún cambio en
					nuestra política de privacidad, anunciaremos en nuestra
					página principal y en otras páginas importantes de nuestro
					sitio que se han hecho tales cambios. Si hay algún cambio en
					nuestra página respecto a la manera en que usamos la
					información de identificación personal de nuestros clientes,
					enviaremos una notificación por correo electrónico o correo
					postal a aquellos que sean afectados por el cambio. Todo
					cambio en nuestra política de privacidad se publicará en
					nuestra página 30 días antes de que tales cambios ocurran.
					Por lo tanto, se recomienda volver a leer esta declaración
					de manera regular.
				</p>
				<p>
					Si se determina que alguna disposición de estas Condiciones
					no se puede ejecutar, las disposiciones restantes seguirán
					en plena vigencia. Si no podemos ejecutar alguna disposición
					de estas Condiciones, ello no se considerará una exención de
					las Condiciones. Cualquier modificación o exención de estas
					Condiciones debe hacerse por escrito y estar firmada por
					ZeroQ.
				</p>
				<p>
					Valoramos siempre los comentarios y cualquier otra
					sugerencia sobre nuestros productos y servicios. No
					obstante, informamos que podemos usarlos sin restricción u
					obligación alguna de brindarle compensación, y no tenemos la
					obligación de mantenerlos en confidencialidad.
				</p>
				<p>Desde ya, ¡gracias por usar nuestra plataforma!</p>
			</Content>
		</Wrapper>
	);
};

export { Terms };
